// extracted by mini-css-extract-plugin
module.exports = {"tabs-navigation":"tabs-navigation_Navigation_2UFgV","tab":"tab_Navigation_2MF3h"};